<template lang="pug">
.Services
  .Services-spinner
    fade-loader.Spinner(
      :loading='isLoading',
      color='#27bd8a',
      height='8px',
      width='3px',
      radius='10px'
    )
  .Services-statistic.Statistic.OneLine(v-if='initialServiceData')
    .Statistic-item
      span.OneLine(
        @mouseover.stop='helperText = "Количество запущенных процессов"',
        @mouseout.stop='helperText = null'
      )
        span.Statistic-icon.Statistic-icon--started
          i.Icon.IconModelingStarted
        | Запущено
        b {{ initialServiceData.working }}
      span.OneLine.Statistic-time(
        v-if='initialServiceData.working && remainingTimeMap.sum && remainingTimeMap.sum.time',
        @mouseover.stop='helperText = "Время до завершения запущенных процессов"',
        @mouseout.stop='helperText = null'
      ) {{ remainingTimeMap.sum.timeText }}
    .Statistic-item.OneLine
      span.OneLine(
        @mouseover.stop='helperText = "Количество процессов ожидающих запуска"',
        @mouseout.stop='helperText = null'
      )
        span.Statistic-icon.Statistic-icon--progress
          i.Icon.IconModelingProgress
        | Ожидание
        b {{ initialServiceData.new }}
    .Statistic-item.OneLine
      span.OneLine(
        @mouseover.stop='helperText = "Количество выполненных процессов"',
        @mouseout.stop='helperText = null'
      )
        span.Statistic-icon.Statistic-icon--success
          i.Icon.IconModelingSuccess
        | Выполнено
        b {{ initialServiceData.finished }}
    .Statistic-item.OneLine
      span.OneLine(
        @mouseover.stop='helperText = "Количество процессов завершенных с ошибкой"',
        @mouseout.stop='helperText = null'
      )
        span.Statistic-icon.Statistic-icon--error
          i.Icon.IconModelingFail
        | Ошибка
        b {{ initialServiceData.error }}
  .Services-limits(v-if='!isLoading')
    limits(
      :isLeft='true',
      :isBottom='true'
    )
  button.Btn.Services-default(
    v-if='moved',
    @click='setDefaultPosition'
  ) Позиционировать по умолчанию
  .Services-tree.Tree(
    v-if='!isLoading',
    :class='{ "Tree--shadowed": selectedService }',
    ref='treeContainer'
  )
    .Tree-wrapper(
      v-if='treeData',
      :style='{ width: treeWidth + "px", height: treeHeight + "px" }'
    )
      Moveable.Tree-drag(
        @drag='onDrag',
        @drag-start='onDragStart',
        @drag-end='onDragEnd',
        v-bind='moveable',
        ref='moveable',
        :style='{ width: treeWidth + "px", height: treeHeight + "px" }'
      )
        div
          template(v-for='element in treeData')
            .ElementWrapper(
              :style='{ left: element.left + "px", top: element.top + "px", width: element.width + "px" }',
              @mouseenter='elementWrapperMouseEnter(element)',
              @mouseleave='elementWrapperMouseLeave'
            )
              .Element-switcher(
                v-if='$store.getters.permissions.canEditDataVersion && (element === hoveredElement || selectedElementIds.includes(element.id))',
                @mousedown.stop=''
              )
                switcher(
                  :isEnabled='selectedElementIds.includes(element.id)',
                  @toggle='handleElementSwitcher($event, element.id)'
                )
              .Element(
                @mousedown='$event.stopImmediatePropagation()',
                @mouseover.stop='toggleElementHelperText(element)',
                @mouseout.stop='helperText = null',
                :class='{ "Element--working": element.status === "working", "Element--selected": selectedService && selectedService.id === element.id, "Element--inactive": element.inactive, Pointer: !element.inactive }',
                @click='debounceOpenService(element)'
              )
                .Element-status
                  i.Icon.IconModelingSuccess(v-if='element.status === "previous_finished"')
                  i.Icon.IconModelingFail(v-else-if='element.status === "previous_error"')
                  .Element-progress(v-else-if='element.status === "working"')
                    svg(
                      viewBox='0 0 18 18',
                      fill='none',
                      xmlns='http://www.w3.org/2000/svg'
                    )
                      path(
                        :d='describeArc(9, 9, 9, 0, (remainingTimeMap[element.id].percentage / 100) * 360)',
                        fill='#0288F3'
                      )

                  i.Icon.IconModelingProgress(v-else-if='element.status === "new"')
                  i.Icon.IconModelingEmpty(v-else-if='element.status === "not_started"')
                .Element-name
                  | {{ element.name }}
                .Element-time(v-if='element.status === "working" && remainingTimeMap[element.id] && remainingTimeMap[element.id].time > 0')
                  | {{ remainingTimeMap[element.id].timeText }}
            .Arrow(
              v-for='arrow in element.arrows',
              :class='[arrow.className]',
              :style='{ left: arrow.left + "px", width: arrow.width + "px", height: arrow.height + "px", top: arrow.top + "px" }'
            )
              svg(
                v-if='arrow.className !== "Arrow--vertical"',
                version='1.1'
              )
                path(
                  :d='"M0," + arrow.height + " Q" + arrow.width * 0.1 + "," + arrow.height * 0.65 + " " + arrow.width * 0.5 + "," + arrow.height * 0.5 + " T" + arrow.width + ",0"',
                  v-if='arrow.className === "Arrow--toRight"'
                )
                path(
                  :d='"M0,0 Q" + arrow.width * 0.1 + "," + arrow.height * 0.35 + " " + arrow.width * 0.5 + "," + arrow.height * 0.5 + " T" + arrow.width + "," + arrow.height',
                  v-if='arrow.className === "Arrow--toLeft"'
                )
            .Arrow(
              v-for='arrow in element.dashArrows',
              :class='[arrow.className, "Arrow--dashed"]',
              :style='{ left: arrow.left + "px", width: arrow.width + "px", height: arrow.height + "px", top: arrow.top + "px" }'
            )
              svg(
                v-if='arrow.className !== "Arrow--vertical"',
                version='1.1'
              )
                path(
                  stroke-dasharray='6 4',
                  :d='"M0," + arrow.height + " Q" + arrow.width * 0.1 + "," + arrow.height * 0.65 + " " + arrow.width * 0.5 + "," + arrow.height * 0.5 + " T" + arrow.width + ",0"',
                  v-if='arrow.className === "Arrow--toRight"'
                )
                path(
                  stroke-dasharray='6 4',
                  :d='"M0,0 Q" + arrow.width * 0.1 + "," + arrow.height * 0.35 + " " + arrow.width * 0.5 + "," + arrow.height * 0.5 + " T" + arrow.width + "," + arrow.height',
                  v-if='arrow.className === "Arrow--toLeft"'
                )

  .Services-footer(v-if='!isLoading')
    button#ModelingServices_saveVersion.Btn.Btn--outline(
      v-if='$store.getters.permissions.canCreateDataVersion',
      @click='copyVersion'
    ) Сохранить версию
    button#ModelingServices_copyWs.Btn.Btn--outline(
      v-if='$store.getters.permissions.canCreateWs',
      @click='openCopyWorkspacePopup($store.getters.workspace, $store.getters.version, $store.getters.currentWs[0].name)'
    ) Копировать рабочее пространство
    button#ModelingServices_addWS.Btn.Btn--blue(
      v-if='$store.getters.permissions.canCreateWs',
      @click='addWorkspace'
    ) Создать рабочее пространство
    .Services-run-selected-wrapper(v-if='$store.getters.permissions.canEditDataVersion && selectedElementIds.length > 0')
      button.Services-run-selected-button.Btn.Btn--outline(@click='startSelectedButtons') 
        | Запустить выбранные процессы ({{ selectedElementIds.length }})
      button.Services-run-selected-button.Btn.Btn--outline(@click='clearSelectedButtons') 
        | Снять выделение
</template>

<script>
import { getMaxOfArray, secondsToHHMMSS } from '@/helpers/utils'
import Moveable from 'vue-moveable'
import FadeLoader from 'vue-spinner/src/FadeLoader'
import Limits from '@/components/modeling/Limits'
import { debounce } from 'debounce'
import limits from '@/mixins/limits'
import copyWorkspace from '@/mixins/copyWorkspace'
import { describeArc } from '@/helpers/utils'
import helpertext from '@/mixins/helpertext'
import Switcher from '@/components/Switcher'

export default {
  name: 'modeling-services',

  mixins: [limits, helpertext, copyWorkspace],

  components: {
    Moveable,
    Limits,
    FadeLoader,
    Switcher
  },

  data() {
    return {
      isLoading: false,
      audio: null,
      copyRequest: false,
      treeElementWidth: 300,
      treeElementHeight: 52,
      treeHeightGutter: 50,
      treeWidth: 0,
      treeHeight: 0,
      isDragged: false,
      numColumnsInRows: [],
      treeUpdInterval: null,
      remainingTimeMap: {
        sum: {
          time: 0,
          timeText: '00:00:00'
        }
      },
      remainingTimeInterval: null,
      moved: false,
      moveable: {
        draggable: true,
        throttleDrag: 0,
        resizable: false,
        throttleResize: 1,
        keepRatio: false,
        scalable: false,
        throttleScale: 0,
        rotatable: false,
        throttleRotate: 0,
        pinchable: false, // ["draggable", "resizable", "scalable", "rotatable"]
        origin: false
      },

      /**Элемент на который навели мышь */
      hoveredElement: null,

      /**Идентификаторы выбранных элементов */
      selectedElementIds: []
    }
  },
  computed: {
    selectedSound() {
      return this.$store.getters.modelingSelectedSound
    },
    modelingSoundsMap() {
      return this.$store.getters.modelingSoundsMap
    },
    selectedService() {
      return this.$store.getters.modelingSelectedService
    },
    initialServiceData() {
      return this.$store.getters.modelingServiceData
    },
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    modelingSound() {
      return this.$store.getters.modelingSound
    },
    treeData() {
      const initialTree = this.initialServiceData ? this.initialServiceData.tree : null
      if (!initialTree) {
        return
      }
      if (initialTree.length >= 8 && (!this.initialServiceData.type || this.initialServiceData.type === 'default')) {
        initialTree[3] = initialTree[3].reverse()
        initialTree[5].push({})
        initialTree[5].push({})
        initialTree[6].push({})
        initialTree[6].push({})
        initialTree[8].unshift({})
        initialTree[8].unshift({})
        initialTree[8].unshift({})
        initialTree[10].unshift({})
        initialTree[10].push({})
      }
      if (this.initialServiceData.type === 'moscow') {
        initialTree[7].splice(1, 0, {})
        initialTree[7].splice(1, 0, {})
        initialTree[9] = initialTree[9].reverse()
        initialTree[10].unshift({})
      }
      if (this.initialServiceData.type === 'moscow_modeldata') {
        initialTree[6].splice(1, 0, {})
        initialTree[6].splice(1, 0, {})
        initialTree[8] = initialTree[8].reverse()
        initialTree[9].unshift({})
      }

      const columns = initialTree.map((v) => v.length)
      const maxColumn = getMaxOfArray(columns)
      const maxRow = initialTree.length
      this.treeWidth = this.treeElementWidth * maxColumn + 20
      this.treeHeight = this.treeElementHeight * maxRow + this.treeHeightGutter * maxRow + 20
      let tree = []
      initialTree.forEach((row, rowIndex) => {
        row.forEach((item, itemIndex) => {
          if (item.id) {
            // let width = this.treeWidth / row.length
            let width = this.treeElementWidth
            const basicLeft = (this.treeWidth - row.length * this.treeElementWidth) / 2
            let left = basicLeft + itemIndex * width + 10
            tree.push({
              ...item,
              time_elapsed: item.time_elapsed ? parseInt(item.time_elapsed) : 0,
              width,
              left,
              top: rowIndex * (this.treeElementHeight + this.treeHeightGutter) + 10,
              center: left + width / 2,
              selected: false
            })
          }
        })
      })
      const generateArrows = (dependency, item) => {
        const arrows = []
        const parent = tree.filter((p) => p.id === dependency)[0]
        //console.log(dependency, item, parent)
        if (parent.top < item.top - this.treeHeightGutter - this.treeElementHeight) {
          const meToTreeCenter = Math.abs(this.treeWidth / 2 - item.center)
          const parentToTreeCenter = Math.abs(this.treeWidth / 2 - parent.center)
          const topArrow = {
            className: 'Arrow--vertical',
            left: parentToTreeCenter < meToTreeCenter ? item.center : parent.center,
            width: 0,
            top: parentToTreeCenter < meToTreeCenter ? parent.top + 1.5 * this.treeElementHeight + this.treeHeightGutter : parent.top + this.treeElementHeight,
            height: item.top - parent.top - 1.5 * this.treeElementHeight - this.treeHeightGutter
          }
          const sideArrow = {
            className: parent.center > item.center ? 'Arrow--toRight' : parent.center < item.center ? 'Arrow--toLeft' : 'Arrow--vertical',
            left: Math.min(item.center, parent.center),
            width: Math.abs(parent.center - item.center),
            top: parentToTreeCenter < meToTreeCenter ? parent.top + this.treeElementHeight : item.top - this.treeHeightGutter - 0.5 * this.treeElementHeight,
            height: this.treeHeightGutter + this.treeElementHeight / 2
          }
          arrows.push(topArrow)
          arrows.push(sideArrow)
        } else {
          const sideArrow = {
            className: parent.center > item.center ? 'Arrow--toRight' : parent.center < item.center ? 'Arrow--toLeft' : 'Arrow--vertical',
            left: Math.min(item.center, parent.center),
            width: Math.abs(parent.center - item.center),
            top: parent.top + this.treeElementHeight,
            height: Math.abs(parent.center - item.center) ? this.treeHeightGutter : item.top - parent.top - this.treeElementHeight
          }
          arrows.push(sideArrow)
        }
        return arrows
      }
      tree = tree.map((item) => {
        let arrows = []
        item.dependencies.forEach((v) => {
          arrows = arrows.concat(generateArrows(v, item))
        })
        let dashArrows = []
        item.facultative_dependencies.forEach((v) => {
          dashArrows = dashArrows.concat(generateArrows(v, item))
        })

        return {
          ...item,
          arrows,
          dashArrows
        }
      })

      /*if(!this.moved) {
          setTimeout(() => {
            if (this.$refs.treeContainer) {
              const containerWidth = this.$refs.treeContainer.clientWidth
              this.$refs.treeContainer.scrollLeft = containerWidth < this.treeWidth ? (this.treeWidth - containerWidth) * 0.5 : 0
            }
          }, 300)
        }*/
      return tree
    }
  },
  watch: {
    remainingTimeMap(newVal, oldVal) {
      const needUpdate = Object.keys(newVal)
        .filter((v) => v !== 'sum')
        .some((v) => !newVal[v].time && oldVal[v] && oldVal[v].time)
      if (needUpdate) {
        this.getServiceTree()
      }
    },
    selectedSound() {
      this.setAudio()
    },
    workspace() {
      this.getServiceTree()
    },
    version() {
      this.getServiceTree()
    },
    treeData(newVal, oldVal) {
      let playSound = false
      if (this.modelingSound && newVal && oldVal) {
        newVal.forEach((v) => {
          if (v.status === 'previous_finished' || v.status === 'previous_error') {
            const oldIndex = oldVal.findIndex((oldV) => oldV.id === v.id)
            if (oldIndex > -1 && oldVal[oldIndex].status !== 'previous_finished' && oldVal[oldIndex].status !== 'previous_error') {
              playSound = true
              this.$store.dispatch('getModelingLimits')
              // console.log(v.id, 'finished')
            }
          }
        })
      }
      if (playSound) {
        this.audio.play()
      }
      this.generateRemainingTime()
    }
  },
  created() {
    this.debounceOpenService = debounce((service) => {
      this.openServiceParameters(service)
      this.$nextTick(() => {
        this.toggleElementHelperText(service)
      })
    }, 50)
  },
  mounted() {
    this.getServiceTree()
    this.setAudio()
  },
  beforeDestroy() {
    clearInterval(this.treeUpdInterval)
    clearInterval(this.remainingTimeInterval)
  },
  methods: {
    describeArc(a, b, c, d, e) {
      return describeArc(a, b, c, d, e) + ` L ${a}, ${a} Z`
    },

    setAudio() {
      this.audio = new Audio(this.modelingSoundsMap[this.selectedSound] || this.modelingSoundsMap.bell1)
      this.audio.preload = 'auto'
    },

    setDefaultPosition() {
      this.$refs.moveable.$el.style.transform = 'none'
      this.moved = false
    },

    onDrag({ target, transform }) {
      target.style.transform = transform
      this.moved = true
      this.isDragged = true
    },

    onDragEnd(e) {
      if (!e.isDrag && e.inputEvent.srcElement.click instanceof Function) {
        e.inputEvent.srcElement.click({ fromMethod: true })
      }
      setTimeout((v) => {
        this.isDragged = false
      }, 100)
    },

    onDragStart(e) {
      if (e && e.preventDefault) {
        this.$refs.moveable.dragStart(e)
      }
    },

    getServiceTree() {
      if (this.workspace && this.version) {
        this.isLoading = true
        this.$store
          .dispatch('getModelingTree')
          .then((r) => {
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
          })
        if (!this.treeUpdInterval) {
          this.treeUpdInterval = setInterval(() => {
            this.$store.dispatch('getModelingTree')
          }, 20000)
        }
      }
    },

    calcPercentage(elapsed, total) {
      elapsed = elapsed > total ? total : elapsed
      const timePercentage = total > 0 ? (elapsed / total) * 100 : 0
      return Math.ceil(timePercentage / 25) * 25 * 0.9999
    },

    generateRemainingTime() {
      const remainingTime = {}
      if (!this.treeData) return
      clearInterval(this.remainingTimeInterval)
      this.remainingTimeInterval = setInterval(this.updateRemainingTime, 1000)
      this.treeData
        .filter((v) => v.status === 'working')
        .forEach((v) => {
          remainingTime[v.id] = {
            percentage: this.calcPercentage(v.time_elapsed, v.time_total),
            time: v.time_elapsed,
            time_total: v.time_total,
            timeText: secondsToHHMMSS(v.time_elapsed)
          }
        })
      this.setRemainingSum(remainingTime)
    },

    updateRemainingTime() {
      const remainingTime = {}
      Object.keys(this.remainingTimeMap)
        .filter((v) => v !== 'sum')
        .forEach((v) => {
          const time = this.remainingTimeMap[v].time - 1 > 0 ? this.remainingTimeMap[v].time - 1 : 0
          remainingTime[v] = {
            percentage: this.calcPercentage(time, this.remainingTimeMap[v].time_total),
            time: time,
            time_total: this.remainingTimeMap[v].time_total,
            timeText: secondsToHHMMSS(time)
          }
        })
      this.setRemainingSum(remainingTime)
    },

    setRemainingSum(remainingTime) {
      const valuesArr = Object.values(remainingTime).map((value) => value.time)
      if (valuesArr.length > 0) {
        const max = getMaxOfArray(valuesArr)
        remainingTime.sum = {
          time: max,
          timeText: secondsToHHMMSS(max)
        }
      } else {
        remainingTime.sum = {
          time: 0,
          timeText: ''
        }
      }
      this.remainingTimeMap = remainingTime
    },

    openServiceParameters(service) {
      if (this.isDragged) {
        return
      }
      if (!this.selectedService || this.selectedService.id !== service.id) {
        this.$store.dispatch('setModelingSelectedService', service)
      } else {
        this.$store.dispatch('setModelingSelectedService', null)
      }
    },

    copyVersion() {
      if (this.checkWorkspaceVerisonLimitReached()) {
        return
      }

      this.$store.dispatch('getModelingLimits').then((r) => {
        if (!this.canCalculate) {
          this.showCanCalculateNotification()
          return
        }

        if (!this.copyRequest) {
          this.copyRequest = true
          this.$store.dispatch('copyVersion').then((v) => {
            this.copyRequest = false
          })
        }
      })
    },

    addWorkspace() {
      if (this.checkWorkspaceVerisonLimitReached()) {
        return
      }

      if (!this.selectedService || this.selectedService.id !== 'workspace') {
        this.$store.dispatch('setModelingSelectedService', {
          id: 'workspace',
          name: 'Создание рабочего пространства'
        })
      }
    },

    toggleElementHelperText(element) {
      if (element.inactive) {
        return
      }

      const isSelected = this.selectedService && this.selectedService.id === element.id
      this.helperText = isSelected ? 'Закрыть настройки процесса' : 'Открыть настройки процесса'
    },

    elementWrapperMouseEnter(element) {
      this.hoveredElement = element
    },

    elementWrapperMouseLeave() {
      this.hoveredElement = null
    },

    handleElementSwitcher(isEnabled, elementId) {
      if (isEnabled) {
        if (!this.selectedElementIds.includes(elementId)) {
          this.selectedElementIds.push(elementId)
        }
      } else {
        const index = this.selectedElementIds.indexOf(elementId)
        if (index > -1) {
          this.selectedElementIds.splice(index, 1)
        }
      }
    },

    startSelectedButtons() {
      return this.$store
        .dispatch('startServiceArray', {
          buttons: this.selectedElementIds
        })
        .then(() => {
          this.$ui.toast.show({ text: 'Запуск сервисов прошел успешно', type: 'success' })
          this.$store.dispatch('getModelingTree')
        })
        .catch((e) => {
          this.$store.commit('setApiErrorInfo', 'При запуске сервисов произошла ошибка. Сервисы не были запущены')
        })
    },

    clearSelectedButtons() {
      this.selectedElementIds = []
    }
  }
}
</script>
<style lang="scss">
@import '~base';

#app .Services {
  --treeItemBg: #{$grey7};
  --treeItemBorder: #{$grey3};
  --treeLine: #{$black2};
  --treeItemColor: #{$black5};
  --treeMenuIcon: #{$grey1};
  --treeMenuBorderIcon: #{$grey3};
  --treeItemPanelBg: #{$white3};
  --treeItemPanelBorder: #{$grey3};
  --blue: #{$blue};
  --treeItemPanelHoverBg: #{$grey7};
  --treeStatisticIconColor: #{$grey11};
  --statisticText: #{$black5};
  --btnBorderColor: #{$grey3};
  --btnTextColor: #{$blue};
  --btnBg: transparent;
}

#app[data-theme='dark'] .Services {
  --treeItemBg: #{$black3};
  --treeItemBorder: #{$black3};
  --treeLine: #{$black3};
  --treeItemColor: #{$white3};
  --treeMenuIcon: #{$grey1};
  --treeMenuBorderIcon: #{$grey8};
  --treeItemPanelBg: #{$black3};
  --treeItemPanelBorder: #{$black1};
  --blue: #{$blue};
  --treeItemPanelHoverBg: #{$black2};
  --treeStatisticIconColor: #{$grey1};
  --statisticText: #{$grey1};
  --btnBorderColor: transparent;
  --btnTextColor: #{$white3};
  --btnBg: #{$blue};
}
</style>
<style scoped lang="scss">
@import '~base';

.Statistic {
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid var(--delimiter);

  &-item {
    flex: 1 1 auto;
    padding: 0 15px;
    justify-content: space-between;
    display: flex;
    border-right: 1px solid var(--delimiter);
    color: var(--statisticText);
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    line-height: 36px;

    &:last-child {
      border: 0;
    }

    & > span {
      display: flex;
      align-items: center;
      flex: 0 1 auto;
    }

    b {
      flex: 0 0 auto;
      margin-left: 5px;
      font-size: 14px;
      font-weight: 500;
      color: var(--basicText);
    }
  }

  &-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    border-radius: 50%;

    .Icon {
      line-height: 24px;
    }

    &--success {
      color: var(--treeStatisticIconColor);
      border: 1px solid var(--treeStatisticIconColor);
    }

    &--error {
      color: var(--treeStatisticIconColor);
      border: 1px solid var(--treeStatisticIconColor);
    }

    &--progress {
      color: var(--treeStatisticIconColor);
      border: 1px solid var(--treeStatisticIconColor);
    }

    &--started {
      color: var(--treeStatisticIconColor);

      .Icon {
        font-size: 24px;
      }
    }
  }
}

.Services {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  &-limits {
    position: absolute;
    margin-left: 15px;
    top: 42px;
    z-index: 5000;
  }

  &-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -16px 0 0 -16px;
  }

  &-statistic {
    flex: 0 0 auto;
  }

  &-tree {
    flex: 1 1 0;
    overflow: auto;
  }

  &-footer {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    border-top: 1px solid var(--delimiter);
    padding: 11px 15px;

    button {
      min-width: 100px;
      max-width: 30%;
      margin-right: 15px;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 11px;
    }

    button.Services-run-selected-button {
      max-width: none;
    }

    .Btn--outline {
      border-color: var(--btnBorderColor);
      color: var(--btnTextColor);
      background: var(--btnBg);
    }
  }

  &-default {
    position: absolute;
    left: 0;
    top: 80px;
    z-index: 1000;
    padding: 10px;
    border-radius: 0 4px 4px 0;
    background: var(--appBg);
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 300;
  }

  &-run-selected-wrapper {
    display: flex;
    flex: 1 1 auto;
    flex-direction: row-reverse;
  }
}

.Tree {
  position: relative;
  height: 0;
  width: 100%;

  &-drag {
    padding: 10px;
    &--draggable {
      box-shadow: 0 0 2px 0 var(--treeItemBorder);

      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        cursor: move;
      }
    }
  }

  &-wrapper {
    position: relative;
    margin: 10px auto 10px;
  }

  &--shadowed {
    .Element,
    .Arrow {
      opacity: 0.5;
    }

    .Element.Pointer:hover {
      background: var(--treeItemBg);
      opacity: 1;
    }

    .Element--selected {
      opacity: 1;
    }
  }
}

.ElementWrapper {
  position: absolute;
}

.Element {
  position: relative;
  display: flex;
  align-items: center;
  height: 52px;
  width: 196px;
  margin: 0 auto;
  padding: 0 10px 0 5px;
  border-radius: 16px;
  border: 1px solid var(--treeItemBorder);
  background: var(--treeItemBg);
  z-index: 5;
  transition: all 0.5s;
  user-select: none;
  cursor: pointer;

  &-progress {
    border: 1px solid var(--accentColor);
    padding: 2px;
    height: 24px;
    width: 24px;
    border-radius: 50%;
  }

  &--working {
    padding-bottom: 7px;
  }

  &.Pointer:hover {
    background: var(--treeItemBorder);
  }

  &-time {
    position: absolute;
    bottom: 1px;
    right: 10px;
    font-size: 11px;
    font-family: 'Roboto Mono', monospace;
    color: var(--secondaryText);
  }

  &--inactive {
    opacity: 0.6;
  }

  &-status {
    flex: 0 0 auto;
    width: 24px;
    margin-right: 4px;

    .Icon {
      display: block;
      font-size: 22px;
      width: 24px;
      height: 24px;
      line-height: 22px;
      border: 1px solid;
      border-radius: 50%;
      text-align: center;
    }

    .IconModelingSuccess {
      color: $green;
      border-color: $green;
    }
    .IconModelingStarted {
      color: $blue;
      border: 0;
      font-size: 24px;
    }

    .IconModelingFail {
      color: $red;
      border-color: $red;
    }

    .IconModelingEmpty {
      color: $grey1;
      border-color: $grey1;
    }

    .IconModelingProgress {
      color: var(--basicText);
      border-color: var(--basicText);
    }
  }

  &-name {
    flex: 1 1 auto;
    max-width: 158px;
    color: var(--treeItemColor);
    font-size: 13px;
    line-height: 1;
    max-height: 38px;
    overflow: hidden;
    word-wrap: break-word;
  }

  &-switcher {
    position: absolute;
    right: 4px;
    top: 15px;
    z-index: 1;
  }
}

.Arrow {
  position: absolute;
  display: block;
  min-width: 1px;

  svg {
    width: 100%;
    height: 100%;
  }

  &--vertical {
    background: var(--treeLine);

    &.Arrow--dashed {
      background: transparent;
      width: 0;
      border-left: 1px dashed var(--treeLine);
    }
  }
  path {
    fill: none;
    stroke: var(--treeLine);
  }

  &--hovered {
    z-index: 8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modeling/Services.vue